export const styles = {
  container: {
    borderRadius: '12px',
    border: '1px solid #EDEFF7',
  },
  content: {
    padding: '16px',
  },
  itemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
};
